const ADMIN_AUTH_KEY = 'cryptoFogWebAdminAuth';

export function buildBasicAuth(username, password) {
  return `Basic ${window.btoa(`${username}:${password}`)}`;
}

export function saveAdminAuth(authHeader) {
  window.sessionStorage.setItem(ADMIN_AUTH_KEY, authHeader);
}

export function readAdminAuth() {
  return window.sessionStorage.getItem(ADMIN_AUTH_KEY);
}

export function clearAdminAuth() {
  window.sessionStorage.removeItem(ADMIN_AUTH_KEY);
}

export async function loadAppRelease(authHeader) {
  return requestJson('/api/web-admin/app-release', {
    headers: {
      Authorization: authHeader,
    },
  });
}

export async function uploadApk(authHeader, file) {
  const formData = new FormData();
  formData.append('file', file);

  return requestJson('/api/web-admin/app-release/apk', {
    method: 'POST',
    headers: {
      Authorization: authHeader,
    },
    body: formData,
  });
}

async function requestJson(url, options) {
  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(await resolveErrorMessage(response));
  }
  return response.json();
}

async function resolveErrorMessage(response) {
  try {
    const body = await response.json();
    return body.message || body.detail || body.error || 'Не удалось выполнить запрос.';
  } catch (_) {
    if (response.status === 401) {
      return 'Неверный логин или пароль.';
    }
    return 'Не удалось выполнить запрос.';
  }
}
